package com.tovtalk.ui.platform

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.tovtalk.di.koinInject
import com.tovtalk.domain.entity.DomainResult
import com.tovtalk.domain.repository.AuthManager
import com.tovtalk.utils.logger.Logger
import com.tovtalk.utils.strings.StringProvider
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.painterResource
import tovtalk_kmp_v2.android_ui.generated.resources.Res
import tovtalk_kmp_v2.android_ui.generated.resources.ic_google_g

@Composable
actual fun TovTalkGoogleSignInButton(
    onSignInSuccess: (idToken: String, accessToken: String?) -> Unit,
    onSignInError: (Throwable) -> Unit,
    modifier: Modifier,
    enabled: Boolean,
    onSignInStart: () -> Unit,
) {
    val authManager: AuthManager = koinInject()
    val scope = rememberCoroutineScope()

    Button(
        onClick = {
            onSignInStart()
            Logger.d("GooglePopup: GoogleSignInButton CLICKED", "GooglePopup")
            scope.launch {
                when (val r = authManager.signInWithGoogleAndGetFirebaseToken("")) {
                    is DomainResult.Success -> {
                        Logger.d("GooglePopup: got Firebase token from popup", "GooglePopup")
                        onSignInSuccess(r.data, null)
                    }
                    is DomainResult.Error -> {
                        if (r.message.orEmpty().contains("Redirecting")) {
                            Logger.d("GooglePopup: GoogleSignInButton got Redirecting (legacy)", "GooglePopup")
                        } else {
                            Logger.e("GooglePopup: GoogleSignInButton got Error ${r.message}", "GooglePopup")
                            onSignInError(Throwable(r.message ?: "Google sign-in failed"))
                        }
                    }
                    is DomainResult.Loading -> { }
                }
            }
        },
        modifier = modifier
            .fillMaxWidth()
            .height(56.dp),
        enabled = enabled,
        shape = RoundedCornerShape(12.dp),
        colors = ButtonDefaults.buttonColors(
            containerColor = Color.White,
            contentColor = Color.Black,
            disabledContainerColor = Color.White.copy(alpha = 0.5f),
            disabledContentColor = Color.Black.copy(alpha = 0.5f),
        ),
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center,
        ) {
            Image(
                painter = painterResource(Res.drawable.ic_google_g),
                contentDescription = null,
                modifier = Modifier.size(24.dp),
            )
            Spacer(Modifier.width(12.dp))
            Text(
                text = StringProvider.get("auth_continue_google"),
                fontSize = 15.sp,
                fontWeight = FontWeight.SemiBold,
            )
        }
    }
}
